import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-distribute",
  "use": "icon-distribute-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-distribute\"><path d=\"M550.229333 967.111111a40.732444 40.732444 0 0 0 40.504889-35.669333l0.284445-5.12v-169.301334a56.888889 56.888889 0 0 0-55.978667-56.888888l-211.342222-3.413334a56.888889 56.888889 0 0 1-55.921778-56.888889V432.924444a56.888889 56.888889 0 0 0-56.888889-56.888888H40.789333a40.732444 40.732444 0 0 0-40.504889 35.669333L0 416.881778v509.496889c0 20.48 15.303111 37.831111 35.669333 40.391111l5.12 0.341333h509.44zM967.111111 550.229333a40.732444 40.732444 0 0 1-35.669333 40.504889l-5.12 0.284445h-169.301334a56.888889 56.888889 0 0 1-56.888888-55.978667l-3.413334-211.342222a56.888889 56.888889 0 0 0-56.888889-55.921778H432.924444a56.888889 56.888889 0 0 1-56.888888-56.888889V40.789333c0-20.593778 15.303111-37.888 35.669333-40.504889L416.881778 0h509.496889c20.48 0 37.831111 15.303111 40.391111 35.669333l0.341333 5.12v509.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/distribute.svg
// module id = nse/
// module chunks = 78